import clsx from "clsx";
import {
  GATE_PHASES,
  OUTLINE_PHASES,
  OUTLINE_USER_GATES_FLAG,
  STEP_LABELS,
} from "constants/outlineGeneration";
import useFeatureFlag from "hooks/useFeatureFlag";
import { AlertCircle, Check } from "lucide-react";
import { bool, string } from "prop-types";

import classes from "./PhaseStepper.module.scss";

const stepState = (phase, index, activeIndex, failed, awaitingGate) => {
  if (failed && index === activeIndex) {
    return "failed";
  }
  if (index < activeIndex) {
    return "done";
  }
  if (index === activeIndex) {
    if (awaitingGate && GATE_PHASES.includes(phase)) {
      return "awaiting";
    }
    return "active";
  }
  return "pending";
};

const stepIcon = (state) => {
  if (state === "done") {
    return <Check size={14} aria-hidden />;
  }
  if (state === "awaiting") {
    return <AlertCircle size={14} aria-hidden />;
  }
  return null;
};

const PhaseStepper = ({
  currentPhase = null,
  failed = false,
  awaitingGate = false,
}) => {
  const userGatesEnabled = useFeatureFlag(OUTLINE_USER_GATES_FLAG);

  const phases =
    userGatesEnabled || GATE_PHASES.includes(currentPhase)
      ? OUTLINE_PHASES
      : OUTLINE_PHASES.filter((phase) => !GATE_PHASES.includes(phase));
  const activeIndex = phases.indexOf(currentPhase);

  return (
    <ol className={classes["stepper"]}>
      {phases.map((phase, index) => {
        const state = stepState(
          phase,
          index,
          activeIndex,
          failed,
          awaitingGate
        );
        return (
          <li
            key={phase}
            data-state={state}
            className={clsx(
              classes["stepper__step"],
              classes[`stepper__step--${state}`]
            )}
          >
            <span className={classes["stepper__dot"]}>{stepIcon(state)}</span>
            <span className={classes["stepper__label"]}>
              {STEP_LABELS[phase]}
            </span>
          </li>
        );
      })}
    </ol>
  );
};

PhaseStepper.propTypes = {
  currentPhase: string,
  failed: bool,
  awaitingGate: bool,
};

export default PhaseStepper;
